import { render } from "./ReservationPhenotypeView.vue?vue&type=template&id=86735cbe&scoped=true"
import script from "./ReservationPhenotypeView.vue?vue&type=script&lang=js"
export * from "./ReservationPhenotypeView.vue?vue&type=script&lang=js"

import "./ReservationPhenotypeView.vue?vue&type=style&index=0&id=86735cbe&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86735cbe"]])

export default __exports__